/**
 * @flow
 */

import styled from 'react-emotion'
import { Typo24DarkGreyBlueTwoNBI } from '../../../../../themes/Fonts/Nort'
import { Typo14BlueGreyDR } from '../../../../../themes/Fonts/Din2014'
import { mobile, tablet } from '../../../../../utils/mixins'
import CloudinaryS3LazyLoadedImage from '../../../../CloudinaryS3LazyLoadedImage'

export const SectionImage = styled(CloudinaryS3LazyLoadedImage)`
  width: 99%;
  object-fit: contain;
  background-color: transparent;
  margin: 0px;
`
export const FutureItemImg = styled(CloudinaryS3LazyLoadedImage)`
  width: 99%;
  object-fit: contain;
  background-color: transparent;
  margin: 0px;
`

export const FutureTextItem = styled('div')`
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  ${mobile} {
    align-items: center;
  }
`
export const FutureItemHead = styled('div')`
  text-align: center;
`

export const FutureItemTitle = styled(Typo24DarkGreyBlueTwoNBI)`
  align-self: flex-start;
  text-align: left;
  margin: 0;
  line-height: normal;
  ${mobile} {
    margin: 0;
    margin-top: 30px;
    text-align: center;
    margin-bottom: 10px;
    align-self: center;
    font-size: 18px;
  }
`
export const FutureImageItem = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 5% 2%;
  border-radius: 6px;
  @media (min-width: 426px) and (max-width: 767px) {
    padding: 20px 3px;
  }
  @media screen and (max-width: 425px) {
    padding: 15px 0px;
  }
`

export const FutureSection = styled('section')`
  ${tablet} {
    margin-bottom: 40px;
  }
`

export const FutureItemDescription = styled(Typo14BlueGreyDR)`
  margin-top: 10px;
  ${mobile} {
    text-align: center;
  }
`



// WEBPACK FOOTER //
// ./src/components/TeamNew/FollowUsSection/components/Section/styledComponents.js